import { TERMINE_KALENDER_DELETE } from '@/domain/termine/hooks/graphql/mutation';
import {
  Termine_KalenderDeleteMutation,
  Termine_KalenderDeleteMutationVariables,
} from '@/gql/graphql';
import * as Sentry from '@sentry/react';
import { useMutation } from '@apollo/client/react';

export function useDeleteTerminKalender() {
  const [mutate, { loading }] = useMutation<
    Termine_KalenderDeleteMutation,
    Termine_KalenderDeleteMutationVariables
  >(TERMINE_KALENDER_DELETE, {
    refetchQueries: [
      'GetTagesDaten',
      'GetTermineKalenderByStandortIdAndZeitraum',
    ],
    awaitRefetchQueries: true,
  });

  const deleteTerminKalender = async (
    variables: Termine_KalenderDeleteMutationVariables,
  ) => {
    try {
      const result = await mutate({ variables });

      if (result.error) {
        throw new Error(
          `Kalender löschen fehlgeschlagen: ${result.error.message}`,
        );
      }

      if (result.data?.termine_terminKalenderDelete.error) {
        throw new Error(
          `Kalender löschen fehlgeschlagen ${result.data.termine_terminKalenderDelete.error.details}`,
        );
      }
      return result.data?.termine_terminKalenderDelete;
    } catch (err) {
      Sentry.captureException(err);
      const message = err instanceof Error ? err.message : String(err);
      return { error: { message }, errorType: 'unexpected' };
    }
  };
  return { deleteTerminKalender, loading };
}
